import React from 'react';

import { UserProvider } from './user.context';
import { DimensionsProvider } from './dimensions.context';

const StoreProvider = ({ children }) => {
  return (
    <DimensionsProvider>
      <UserProvider>
      {children}
      </UserProvider>
    </DimensionsProvider>
  );
};

export default StoreProvider;
